<template>
  <div class="text-right apex-chart-controls">
    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button type="icon" color="cinza-0" icon="first_page" size="sm" @click="goToFirstPosition" />
      </template>
      <span>Início</span>
    </mf-tooltip>

    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button
          type="icon"
          color="cinza-0"
          icon="chevron_left"
          size="sm"
          @mousedown="clickAndHoldStart('backIntervalValuePosition')"
          @mouseup="clickAndHoldStop"
          @mouseleave="clickAndHoldStop"
        />
      </template>
      <span>{{ interval }} para a esquerda</span>
    </mf-tooltip>

    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button
          type="icon"
          color="cinza-0"
          icon="arrow_left"
          size="sm"
          @mousedown="clickAndHoldStart('backOnePosition')"
          @mouseup="clickAndHoldStop"
          @mouseleave="clickAndHoldStop"
        />
      </template>
      <span>1 para a esquerda</span>
    </mf-tooltip>

    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button
          type="icon"
          color="cinza-0"
          icon="arrow_right"
          size="sm"
          @mousedown="clickAndHoldStart('advanceOnePosition')"
          @mouseup="clickAndHoldStop"
          @mouseleave="clickAndHoldStop"
        />
      </template>
      <span>1 para a direita</span>
    </mf-tooltip>

    <mf-tooltip bottom>
      <template v-slot:activator="{ on }">
        <mf-button
          type="icon"
          color="cinza-0"
          icon="chevron_right"
          size="sm"
          @mousedown="clickAndHoldStart('advanceIntervalValuePosition')"
          @mouseup="clickAndHoldStop"
          @mouseleave="clickAndHoldStop"
        />
      </template>
      <span>{{ interval }} para a direita</span>
    </mf-tooltip>

    <mf-tooltip bottom>
      <template #activator="{ on }">
        <mf-button type="icon" icon="last_page" size="sm" color="cinza-0" @click="goToLastPosition" />
      </template>
      <span>Final</span>
    </mf-tooltip>
    <span>{{ currentPosition + 1 }}/{{ maxPosition + 1 }}</span>
  </div>
</template>

<script>
export default {
  name: 'ApexChartNavigator',

  props: {
    chartLabelsLength: {
      type: Number,
      required: false,
      default: 0,
    },

    interval: {
      type: Number,
      required: false,
      default: 13,
    },

    currentPosition: {
      type: Number,
      required: false,
      default: 0,
    },

    filterType: {
      type: String,
      required: false,
      default: 'mensal',
    },
  },

  data() {
    return {
      timeout: null,
    }
  },

  computed: {
    maxPosition() {
      if (this.chartLabelsLength > this.interval) {
        return this.chartLabelsLength - this.interval
      }
      return 0
    },
  },

  watch: {
    filterType: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('update:currentPosition', this.maxPosition)
        }
      },
      immediate: false,
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$emit('update:currentPosition', this.maxPosition)
    })
  },

  beforeDestroy() {
    this.clickAndHoldStop()
  },

  methods: {
    goToFirstPosition() {
      this.$emit('update:currentPosition', 0)
    },
    backOnePosition() {
      if (this.currentPosition > 0) {
        this.$emit('update:currentPosition', this.currentPosition - 1)
      }
    },
    backIntervalValuePosition() {
      if (this.currentPosition > this.interval) {
        this.$emit('update:currentPosition', this.currentPosition - this.interval)
      } else if (this.currentPosition > 0) {
        this.$emit('update:currentPosition', 0)
      }
    },
    advanceOnePosition() {
      if (this.currentPosition < this.maxPosition) {
        this.$emit('update:currentPosition', this.currentPosition + 1)
      }
    },
    advanceIntervalValuePosition() {
      if (this.currentPosition < this.maxPosition - this.interval) {
        this.$emit('update:currentPosition', this.currentPosition + this.interval)
      } else if (this.currentPosition < this.maxPosition) {
        this.$emit('update:currentPosition', this.maxPosition)
      }
    },
    goToLastPosition() {
      this.$emit('update:currentPosition', this.maxPosition)
    },
    clickAndHoldStart(method) {
      this[method]()
      this.timeout = setTimeout(() => {
        this.clickAndHoldStart(method)
      }, 100)
    },
    clickAndHoldStop() {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
    },
  },
}
</script>

<style scoped>
.apex-chart-controls {
  user-select: none;
}
</style>
